<template>
  <main class="auth-page">
    <div class="auth-glow auth-glow-one" />
    <div class="auth-glow auth-glow-two" />
    <section class="login-card">
      <div class="brand-lockup">
        <img src="@/assets/logo2.png" alt="智猎招聘" />
      </div>
      <div class="login-heading">
        <h1>登录你的账号</h1>
        <p>欢迎使用智猎招聘管理平台</p>
      </div>
      <el-form ref="loginForm" :model="formData" :rules="rules" class="login-form" @submit.native.prevent="submitLogin">
        <el-form-item prop="account">
          <el-input v-model.trim="formData.username" size="large" autocomplete="username" placeholder="账号"
            prefix-icon="el-icon-user" @keyup.enter.native="submitLogin" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="formData.password" size="large" type="password" show-password
            autocomplete="current-password" placeholder="密码" prefix-icon="el-icon-lock"
            @keyup.enter.native="submitLogin" />
        </el-form-item>
        <div class="login-options">
          <el-checkbox v-model="rememberAccount">记住我</el-checkbox>
        </div>
        <el-button class="auth-submit" type="primary" :loading="loading" @click="submitLogin">
          {{ loading ? '正在登录…' : '登录' }}
        </el-button>
      </el-form>
      <div class="login-footer"><span class="footer-dot" />安全登录 · 智猎招聘</div>
    </section>
  </main>
</template>

<script>
import { Login } from '../request/api'
export default {
  data() {
    return {
      formData: { username: '', password: '' },
      rememberAccount: true,
      loading: false,
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  created() {
    if (localStorage.getItem('Login') !== null) {
      this.formData.username = JSON.parse(localStorage.getItem('Login')).username
      this.formData.password = JSON.parse(localStorage.getItem('Login')).password
      this.rememberAccount = true;
      this.submitLogin();
    } else {
      this.rememberAccount = false;
    }
  },
  methods: {
    async submitLogin() {
      if (this.formData.password === '' || this.formData.username === '') {
        this.$message.warning('请填写用户名和密码！');
        return;
      }

      var { data: res } = await Login(this.formData);
      if (res.code === 200) {
        if (this.rememberAccount) {
          localStorage.setItem('Login', JSON.stringify(this.formData));
        }
        this.$message.success('登录成功!');
        sessionStorage.setItem('LoginInfo', JSON.stringify(res.data))
        window.dispatchEvent(new Event('login-info-change'))
        this.$router.push('/assistant');
      } else {
        localStorage.removeItem('Login');
        this.$message.error(res.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-page {
  position: relative;
  display: grid;
  place-items: center;
  min-height: 100vh;
  padding: 32px 18px;
  overflow: hidden;
  background: radial-gradient(ellipse at 80% 10%, rgba(65, 78, 151, .15), transparent 34%), #101725;
}

.auth-glow {
  position: absolute;
  width: 360px;
  height: 360px;
  border-radius: 50%;
  filter: blur(90px);
  pointer-events: none;
}

.auth-glow-one {
  top: -230px;
  right: -70px;
  background: rgba(81, 96, 220, .16);
}

.auth-glow-two {
  bottom: -270px;
  left: -100px;
  background: rgba(27, 105, 190, .12);
}

.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
  padding: 35px 50px;
  border: 1px solid rgba(113, 126, 255, .18);
  border-radius: 16px;
  background: linear-gradient(145deg, rgba(26, 34, 53, .98), rgba(17, 24, 38, .99));
  box-shadow: 0 24px 70px rgba(0, 0, 0, .34), inset 0 1px rgba(255, 255, 255, .025);
}

.brand-lockup {
  display: flex;
  align-items: center;

  img {
    position: absolute;
    top: 15px;
    left: 15px;
    width: 100px;
    height: auto;
    border-radius: 11px;
    object-fit: cover;
  }

  strong {
    color: #e2e8f5;
    font-size: 16px;
    letter-spacing: 1px;
  }

  span {
    color: #74819a;
    font-size: 8px;
    letter-spacing: 2px;
  }
}

.login-heading {
  margin: 15px 0 35px;
  text-align: center;

  h1 {
    color: #776cff;
    font-size: 23px;
    font-weight: 700;
    letter-spacing: .2px;
  }

  p {
    margin-top: 9px;
    color: #9aa6bd;
    font-size: 16px;
  }
}

.login-form {
  .el-form-item {
    margin-bottom: 23px;
  }
}

.login-form ::v-deep .el-input__inner {
  height: 50px;
  padding: 0 18px 0 44px;
  border: 1px solid #6258e9;
  border-radius: 7px;
  background: rgba(15, 22, 36, .66);
  color: #e2e7f2;
  font-size: 15px;
  letter-spacing: .3px;
  box-shadow: inset 0 1px 4px rgba(0, 0, 0, .14);
}

.login-form ::v-deep .el-input__inner::placeholder {
  color: #68758f;
}

.login-form ::v-deep .el-input__prefix,
.login-form ::v-deep .el-input__suffix {
  display: flex;
  align-items: center;
  color: #8077ff;
}

.login-form ::v-deep .el-input__inner:focus {
  border-color: #938aff;
  box-shadow: 0 0 0 3px rgba(111, 99, 255, .12);
}

.login-form ::v-deep .el-form-item__error {
  padding-top: 5px;
  color: #ff8b9a;
}

.login-options {
  display: flex;
  justify-content: flex-end;
  margin: 0px 0 15px;
}

.login-options ::v-deep .el-checkbox__label {
  color: #aab4c8;
  font-size: 13px;
}

.login-options ::v-deep .el-checkbox__inner {
  border-color: #556179;
  background: #141c2b;
}

.login-options ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #7469ff;
  background: #7469ff;
}

.auth-submit.el-button--primary {
  width: 100%;
  height: 52px;
  border: 0;
  border-radius: 13px;
  background: linear-gradient(100deg, #695cff, #8275ff);
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  box-shadow: 0 8px 22px rgba(104, 91, 255, .3);
  transition: transform .18s ease, box-shadow .18s ease, filter .18s ease;

  &:hover {
    transform: translateY(-1px);
    filter: brightness(1.07);
    box-shadow: 0 10px 26px rgba(104, 91, 255, .38);
  }

  &:active {
    transform: translateY(0);
  }
}

.login-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 35px;
  color: #65728a;
  font-size: 11px;
  letter-spacing: .4px;
}

.footer-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #42c98b;
  box-shadow: 0 0 8px rgba(66, 201, 139, .55);
}

@media (max-width: 560px) {
  .login-card {
    min-height: 0;
    padding: 25px 24px 26px;
  }

  .login-heading {
    margin-bottom: 30px;
  }
}
</style>
